export const endPoints = {
  GET_ASSIGN_INFO: "/v1/employee/",
  LEAD_EMPLOYEE: "/v1/employee/active",
  ASSIGN_EMPLOYEE: "/v1/employee/assign"
}